module.exports = __webpack_public_path__ + "images/themeIcon-ac46caa217df332524a8be41edf01e9e.svg";